document.documentElement.classList.add('js');
const headerControllers = new WeakMap();
const desktop = window.matchMedia('(min-width: 990px)');
const dialogOpeners = new WeakMap();

function closeMenus(header, restoreFocus = false) {
  const active = header.querySelector('[data-menu-trigger][aria-expanded="true"]');
  header.querySelectorAll('[data-menu-trigger]').forEach(button => button.setAttribute('aria-expanded', 'false'));
  header.querySelectorAll('.mega-panel').forEach(panel => { panel.hidden = true; panel.setAttribute('aria-hidden', 'true'); });
  if (restoreFocus && active) {
    header.dataset.suppressMenuFocus = 'true';
    active.focus();
    delete header.dataset.suppressMenuFocus;
  }
}
function openMenu(header, button) {
  if (!desktop.matches) return;
  const panel = document.getElementById(button.getAttribute('aria-controls'));
  if (!panel) return;
  closeMenus(header);
  panel.hidden = false;
  panel.setAttribute('aria-hidden', 'false');
  button.setAttribute('aria-expanded', 'true');
}
function finishDialog(dialog) {
  dialog.setAttribute('aria-hidden', 'true');
  if (!document.querySelector('dialog[open]')) document.body.classList.remove('dialog-open');
  const opener = dialogOpeners.get(dialog);
  if (opener) {
    opener.setAttribute('aria-expanded', 'false');
    if (opener.isConnected && !document.querySelector('dialog[open]')) opener.focus();
    dialogOpeners.delete(dialog);
  }
}
function closeDialog(dialog) { if (dialog?.open) dialog.close(); }
function showDialog(dialog, opener) {
  if (!dialog || dialog.open) return;
  document.querySelectorAll('dialog[open]').forEach(closeDialog);
  document.querySelectorAll('[data-header]').forEach(header => closeMenus(header));
  dialogOpeners.set(dialog, opener);
  dialog.showModal();
  dialog.setAttribute('aria-hidden', 'false');
  opener.setAttribute('aria-expanded', 'true');
  document.body.classList.add('dialog-open');
  (dialog.querySelector('input[type="search"]') || dialog.querySelector('[data-close-dialog]'))?.focus();
}
function activateTab(tab) {
  tab.closest('dialog').querySelectorAll('[data-nav-tab]').forEach(button => {
    const selected = button === tab;
    button.setAttribute('aria-selected', String(selected));
    button.tabIndex = selected ? 0 : -1;
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (panel) panel.hidden = !selected;
  });
}
function moveGallery(gallery, mediaId) {
  const track = gallery?.querySelector('.gallery-track');
  const slide = [...(track?.children || [])].find(element => element.dataset.mediaId === String(mediaId));
  if (!slide) return;
  track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'auto' });
  gallery.querySelectorAll('[data-gallery-target]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.galleryTarget === String(mediaId))));
}
function updateVariant(section, variantId, updateUrl = true) {
  const data = section.querySelector('[data-variant-data]');
  if (!data) return;
  let variants = [];
  try {
    variants = JSON.parse(data.textContent);
  } catch (e) {
    return;
  }
  const variant = variants.find(item => String(item.id) === String(variantId));
  if (!variant) return;

  const select = section.querySelector('[data-variant-select]');
  if (select) select.value = String(variant.id);

  const priceEl = section.querySelector('[data-variant-price]');
  if (priceEl) priceEl.textContent = variant.price;

  const compare = section.querySelector('[data-variant-compare]');
  if (compare) {
    compare.textContent = variant.compare || '';
    compare.hidden = !variant.compare;
  }

  const submit = section.querySelector('[data-add-to-cart]');
  if (submit) {
    submit.disabled = !variant.available;
    submit.textContent = variant.available ? 'Add to bag' : 'Sold out';
  }

  const statusEl = section.querySelector('[data-variant-status]');
  if (statusEl) statusEl.textContent = variant.available ? '' : 'Sold out';

  section.querySelectorAll('[data-option-position]').forEach(label => {
    label.textContent = variant.options[Number(label.dataset.optionPosition)] || '';
  });

  section.querySelectorAll('[data-choose-variant]').forEach(button => {
    button.setAttribute('aria-pressed', String(button.dataset.chooseVariant === String(variant.id)));
  });

  const dialogAddBtn = section.querySelector('[data-dialog-add-to-bag]');
  if (dialogAddBtn) {
    dialogAddBtn.disabled = !variant.available;
    dialogAddBtn.textContent = variant.available
      ? `Add to bag — ${variant.price}`
      : 'Sold out';
  }

  const trigger = section.querySelector('.variant-dialog-trigger');
  const sizeSummary = section.querySelector('[data-selected-size-display]');
  const sizeText = section.querySelector('[data-selected-size-text]');
  const cleanSize = variant.size || variant.title;

  if (section.dataset.hasChosenSize === 'true') {
    if (trigger) {
      trigger.textContent = variant.available ? 'Add to bag' : 'Sold out';
      trigger.disabled = !variant.available;
    }
    if (sizeSummary) {
      sizeSummary.hidden = false;
    }
    if (sizeText) {
      sizeText.textContent = `Size: ${cleanSize}`;
    }
  } else {
    if (trigger) {
      trigger.textContent = 'Choose Size';
      trigger.disabled = false;
    }
    if (sizeSummary) {
      sizeSummary.hidden = true;
    }
  }

  if (variant.mediaId) moveGallery(section.querySelector('[data-gallery]'), variant.mediaId);
  if (updateUrl) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }
}
let isSwitchingProduct = false;
async function switchProduct(url, pushState = true) {
  if (isSwitchingProduct) return;
  const currentSection = document.querySelector('[data-product-section]');
  if (!currentSection) {
    window.location.href = url;
    return;
  }

  const targetUrl = new URL(url, window.location.origin);
  if (targetUrl.pathname === window.location.pathname && targetUrl.search === window.location.search) {
    return;
  }

  isSwitchingProduct = true;
  currentSection.style.transition = 'opacity 0.2s ease';
  currentSection.style.opacity = '0.5';
  currentSection.style.pointerEvents = 'none';

  try {
    const res = await fetch(targetUrl.href, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!res.ok) {
      window.location.href = targetUrl.href;
      return;
    }
    const html = await res.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const newSection = doc.querySelector('[data-product-section]');

    if (!newSection) {
      window.location.href = targetUrl.href;
      return;
    }

    document.querySelectorAll('dialog[open]').forEach(closeDialog);
    currentSection.replaceWith(newSection);

    if (pushState) {
      window.history.pushState({ path: targetUrl.href }, '', targetUrl.href);
    }
    if (doc.title) {
      document.title = doc.title;
    }

    initialize(newSection);
  } catch (err) {
    console.error('AJAX product switch error:', err);
    window.location.href = targetUrl.href;
  } finally {
    isSwitchingProduct = false;
    const finalSection = document.querySelector('[data-product-section]');
    if (finalSection) {
      finalSection.style.opacity = '1';
      finalSection.style.pointerEvents = '';
    }
  }
}
window.addEventListener('popstate', () => {
  if (document.querySelector('[data-product-section]')) {
    switchProduct(window.location.href, false);
  }
});
let cartDrawerOpener = null;
function getCartDrawer() { return document.querySelector('[data-cart-drawer]'); }
function openCartDrawer(opener = null) {
  const drawer = getCartDrawer();
  if (!drawer) return;
  cartDrawerOpener = opener || document.querySelector('[data-cart-drawer-open]');
  drawer.setAttribute('aria-hidden', 'false');
  document.body.classList.add('cart-drawer-open');
  document.querySelectorAll('[data-cart-drawer-open]').forEach(button => button.setAttribute('aria-expanded', 'true'));
  drawer.querySelector('.cart-drawer__panel')?.focus();
}
function closeCartDrawer() {
  const drawer = getCartDrawer();
  if (!drawer) return;
  drawer.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('cart-drawer-open');
  document.querySelectorAll('[data-cart-drawer-open]').forEach(button => button.setAttribute('aria-expanded', 'false'));
  if (cartDrawerOpener?.isConnected) cartDrawerOpener.focus();
  cartDrawerOpener = null;
}
async function refreshCartDrawer() {
  const drawer = getCartDrawer();
  if (!drawer) return;
  const sectionId = drawer.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-', '');
  if (!sectionId) throw new Error('Cart drawer section is missing');
  const wasOpen = drawer.getAttribute('aria-hidden') === 'false';
  const url = new URL(window.location.pathname, window.location.origin);
  url.searchParams.set('sections', sectionId);
  const response = await fetch(url.toString(), { headers: { Accept: 'application/json' }, cache: 'no-store' });
  if (!response.ok) throw new Error(`Cart drawer refresh failed: ${response.status}`);
  const sections = await response.json();
  const html = sections[sectionId];
  if (!html) throw new Error('Cart drawer section could not be rendered');
  const parsed = new DOMParser().parseFromString(html, 'text/html');
  const next = parsed.querySelector('[data-cart-drawer]');
  if (!next) throw new Error('Cart drawer markup is missing');
  next.setAttribute('aria-hidden', wasOpen ? 'false' : 'true');
  drawer.replaceWith(next);
  const count = parsed.querySelector('[data-cart-count]')?.textContent;
  if (count !== undefined) {
    document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = count; });
    document.querySelectorAll('[data-cart-drawer-open] .visually-hidden').forEach(node => { node.textContent = `Cart, ${count} items`; });
  }
  if (wasOpen) next.querySelector('.cart-drawer__panel')?.focus();
}
async function changeCartLine(line, quantity) {
  const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity)) }) });
  if (!response.ok) throw new Error(`Cart update failed: ${response.status}`);
  await response.json();
  await refreshCartDrawer();
}
async function addProductToCart(form) {
  const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
  if (!response.ok) throw new Error(`Add to cart failed: ${response.status}`);
  await response.json();
  await refreshCartDrawer().catch(error => { console.error('Cart drawer refresh:', error); throw error; });
  openCartDrawer(form.querySelector('[data-add-to-cart]'));
}
function initialize(root = document) {
  const getElements = (selector) => {
    const items = [...root.querySelectorAll(selector)];
    if (root !== document && root.matches && root.matches(selector)) {
      items.unshift(root);
    }
    return items;
  };

  getElements('[data-header]').forEach(header => {
    if (headerControllers.has(header)) return;
    const controller = new AbortController();
    const wrapper = header.closest('[data-header-wrapper]') || header.parentElement;
    const updateHeaderHeight = () => {
      if (header.dataset.headerState === 'top' || !header.dataset.headerState) {
        const height = header.querySelector('.header-row')?.getBoundingClientRect().height || 145;
        document.documentElement.style.setProperty('--header-height', `${height}px`);
        if (wrapper && wrapper.matches('[data-header-wrapper]')) wrapper.style.minHeight = `${height}px`;
      }
    };
    const observer = new ResizeObserver(updateHeaderHeight);
    const headerRow = header.querySelector('.header-row');
    if (headerRow) observer.observe(headerRow);
    headerControllers.set(header, { controller, observer });

    const TOP_THRESHOLD = 10;
    const HIDE_THRESHOLD = 50;
    const SCROLL_TOLERANCE = 4;
    let lastScrollY = Math.max(0, window.pageYOffset || document.documentElement.scrollTop || 0);
    let ticking = false;

    const setHeaderState = (newState) => {
      const needsClassUpdate = !header.classList.contains(`is-${newState}`);
      if (!needsClassUpdate && header.dataset.headerState === newState) return;
      header.dataset.headerState = newState;
      header.setAttribute('data-header-state', newState);
      header.classList.remove('is-top', 'is-hidden', 'is-compact');
      header.classList.add(`is-${newState}`);
      if (newState === 'hidden') {
        closeMenus(header);
      }
      if (newState === 'top') {
        updateHeaderHeight();
      }
    };

    const onScroll = () => {
      if (document.body.classList.contains('dialog-open') || header.querySelector('dialog[open]')) return;
      const currentScrollY = Math.max(0, window.pageYOffset || document.documentElement.scrollTop || 0);
      const delta = currentScrollY - lastScrollY;

      if (currentScrollY <= TOP_THRESHOLD) {
        setHeaderState('top');
      } else if (delta > SCROLL_TOLERANCE && currentScrollY > HIDE_THRESHOLD) {
        setHeaderState('hidden');
      } else if (delta < -SCROLL_TOLERANCE && currentScrollY > TOP_THRESHOLD) {
        setHeaderState('compact');
      }
      lastScrollY = currentScrollY;
    };

    const handleScroll = () => {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(() => {
          onScroll();
          ticking = false;
        });
      }
    };

    window.addEventListener('scroll', handleScroll, { signal: controller.signal, passive: true });
    updateHeaderHeight();
    onScroll();

    header.addEventListener('pointerover', event => { const button = event.target.closest('[data-menu-trigger]'); if (button && event.pointerType === 'mouse') openMenu(header, button); }, { signal: controller.signal });
    header.addEventListener('pointerleave', () => { if (!header.contains(document.activeElement) || document.activeElement.matches('[data-menu-trigger]')) closeMenus(header); }, { signal: controller.signal });
    header.addEventListener('focusout', event => { if (event.relatedTarget && !header.contains(event.relatedTarget)) closeMenus(header); }, { signal: controller.signal });
    closeMenus(header);
  });

  getElements('dialog').forEach(dialog => {
    if (dialog.dataset.initialized) return;
    dialog.dataset.initialized = 'true';
    dialog.setAttribute('aria-hidden', String(!dialog.open));
    dialog.addEventListener('close', () => finishDialog(dialog));
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog(dialog);
    });
  });

  getElements('[data-footer-menu]').forEach(details => { details.open = desktop.matches; });

  getElements('[data-product-section]').forEach(section => {
    const trigger = section.querySelector('.variant-dialog-trigger');
    const hasOnlyDefaultVariant = section.querySelector('[data-has-only-default-variant]')?.value === 'true';
    if (hasOnlyDefaultVariant) {
      section.dataset.hasChosenSize = 'true';
    }
    if (trigger) {
      trigger.hidden = false;
      section.querySelector('.native-variant-selector')?.classList.add('visually-hidden');
      const varSelect = section.querySelector('[data-variant-select]');
      if (varSelect) varSelect.tabIndex = -1;
      const addToCart = section.querySelector('[data-add-to-cart]');
      if (addToCart) addToCart.hidden = true;
    }
    const select = section.querySelector('[data-variant-select]');
    if (select) {
      updateVariant(section, select.value, false);
    }
  });

  getElements('[data-color-carousel]').forEach(carousel => {
    if (carousel.dataset.initialized) return;
    carousel.dataset.initialized = 'true';
    const track = carousel.querySelector('.color-swatch-track');
    const bar = carousel.querySelector('[data-color-indicator]');
    if (!track || !bar) return;
    const updateIndicator = () => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 0) {
        bar.style.width = '100%';
        bar.style.transform = 'none';
        return;
      }
      const ratio = Math.max(0, Math.min(1, track.scrollLeft / maxScroll));
      const trackWidth = carousel.querySelector('.color-indicator-track')?.clientWidth || track.clientWidth;
      const barWidth = Math.max(24, trackWidth * (track.clientWidth / track.scrollWidth));
      bar.style.width = `${barWidth}px`;
      const maxTranslate = trackWidth - barWidth;
      bar.style.transform = `translateX(${ratio * maxTranslate}px)`;
    };
    track.addEventListener('scroll', updateIndicator, { passive: true });
    window.addEventListener('resize', updateIndicator, { passive: true });
    updateIndicator();
  });

  getElements('[data-gallery]').forEach(gallery => {
    if (gallery.dataset.initialized) return;
    gallery.dataset.initialized = 'true';
    const track = gallery.querySelector('.gallery-track');
    if (!track) return;
    track.addEventListener('scroll', () => {
      const slides = [...track.children];
      const closest = slides.reduce((best, slide) => Math.abs(slide.offsetLeft - track.offsetLeft - track.scrollLeft) < Math.abs(best.offsetLeft - track.offsetLeft - track.scrollLeft) ? slide : best, slides[0]);
      if (!closest) return;
      gallery.querySelectorAll('[data-gallery-target]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.galleryTarget === closest.dataset.mediaId)));
      gallery.querySelectorAll('video').forEach(video => { if (!closest.contains(video)) video.pause(); });
    }, { passive: true });
  });

  getElements('.contact-page form').forEach(form => {
    if (form.dataset.initialized) return;
    form.dataset.initialized = 'true';
    const select = form.querySelector('select');
    const fields = form.querySelector('.contact-fields');
    if (!select || !fields) return;
    const update = () => { fields.hidden = !select.value; fields.querySelectorAll('input, textarea, button').forEach(control => { control.disabled = !select.value; }); };
    select.addEventListener('change', update);
    update();
  });
}

document.addEventListener('click', event => {
  const cartOpener = event.target.closest('[data-cart-drawer-open]');
  if (cartOpener) { event.preventDefault(); openCartDrawer(cartOpener); return; }
  const cartCloser = event.target.closest('[data-cart-drawer-close]');
  if (cartCloser) { event.preventDefault(); closeCartDrawer(); return; }
  const quantity = event.target.closest('[data-cart-quantity]');
  if (quantity) { event.preventDefault(); quantity.disabled = true; changeCartLine(quantity.dataset.line, quantity.dataset.quantity).catch(() => { quantity.disabled = false; }); return; }
  const remove = event.target.closest('[data-cart-remove]');
  if (remove) { event.preventDefault(); remove.disabled = true; changeCartLine(remove.dataset.line, 0).catch(() => { remove.disabled = false; }); return; }

  // Fit option click (AJAX switch)
  const fitLink = event.target.closest('.fit-option');
  if (fitLink) {
    event.preventDefault();
    if (!fitLink.classList.contains('is-active')) {
      const container = fitLink.closest('.fit-options');
      if (container) {
        container.querySelectorAll('.fit-option').forEach(el => {
          el.classList.remove('is-active');
          el.setAttribute('aria-checked', 'false');
        });
        fitLink.classList.add('is-active');
        fitLink.setAttribute('aria-checked', 'true');
      }
      switchProduct(fitLink.href);
    }
    return;
  }

  // Color swatch click (AJAX switch)
  const colorLink = event.target.closest('.color-swatch-item a');
  if (colorLink) {
    event.preventDefault();
    const item = colorLink.closest('.color-swatch-item');
    if (!item?.classList.contains('is-active')) {
      const track = colorLink.closest('.color-swatch-track');
      if (track) {
        track.querySelectorAll('.color-swatch-item').forEach(el => el.classList.remove('is-active'));
        item.classList.add('is-active');
      }
      switchProduct(colorLink.href);
    }
    return;
  }

  // Dialog Add to bag button
  const dialogAddBtn = event.target.closest('[data-dialog-add-to-bag]');
  if (dialogAddBtn) {
    event.preventDefault();
    const dialog = dialogAddBtn.closest('dialog');
    const section = dialogAddBtn.closest('[data-product-section]');
    const form = section?.querySelector('.product-form');
    if (dialog) closeDialog(dialog);
    if (form) {
      addProductToCart(form).catch(() => { window.location.href = '/cart'; });
    }
    return;
  }

  // Main page trigger button click
  const trigger = event.target.closest('.variant-dialog-trigger');
  if (trigger) {
    event.preventDefault();
    const section = trigger.closest('[data-product-section]');
    const form = trigger.closest('.product-form');
    if (section?.dataset.hasChosenSize === 'true' && form) {
      addProductToCart(form).catch(() => { window.location.href = '/cart'; });
    } else {
      const dialogId = trigger.dataset.openDialog;
      if (dialogId) {
        showDialog(document.getElementById(dialogId), trigger);
      }
    }
    return;
  }

  // Size option button in dialog
  const variant = event.target.closest('[data-choose-variant]');
  if (variant) {
    const section = variant.closest('[data-product-section]');
    if (section) {
      section.dataset.hasChosenSize = 'true';
      updateVariant(section, variant.dataset.chooseVariant);
    }
    return;
  }

  // Other dialog openers (e.g. Change size link, search, mobile menu)
  const opener = event.target.closest('[data-open-dialog]');
  if (opener) { showDialog(document.getElementById(opener.dataset.openDialog), opener); return; }
  const closer = event.target.closest('[data-close-dialog]');
  if (closer) { closeDialog(closer.closest('dialog')); return; }
  const menu = event.target.closest('[data-menu-trigger]');
  if (menu) { const header = menu.closest('[data-header]'); if (menu.getAttribute('aria-expanded') === 'true') closeMenus(header); else openMenu(header, menu); return; }
  const tab = event.target.closest('[data-nav-tab]');
  if (tab) { activateTab(tab); return; }

  const galleryButton = event.target.closest('[data-gallery-target]');
  if (galleryButton) { moveGallery(galleryButton.closest('[data-gallery]'), galleryButton.dataset.galleryTarget); return; }
  const galleryNav = event.target.closest('[data-gallery-direction]');
  if (galleryNav) {
    const gallery = galleryNav.closest('[data-gallery]');
    const track = gallery?.querySelector('.gallery-track');
    if (track) {
      const dir = Number(galleryNav.dataset.galleryDirection);
      const slides = [...track.children];
      const curIndex = slides.findIndex(slide => Math.abs(slide.offsetLeft - track.offsetLeft - track.scrollLeft) < 20);
      const nextIndex = Math.max(0, Math.min(slides.length - 1, (curIndex === -1 ? 0 : curIndex) + dir));
      track.scrollTo({ left: slides[nextIndex].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    return;
  }
  const carouselButton = event.target.closest('[data-direction]');
  if (carouselButton) { const track = carouselButton.closest('.featured-products').querySelector('.product-carousel'); track?.scrollBy({ left: track.clientWidth * Number(carouselButton.dataset.direction), behavior: 'auto' }); }

  document.querySelectorAll('[data-header]').forEach(header => { if (!header.contains(event.target)) closeMenus(header); });
});
document.addEventListener('change', event => { if (event.target.matches('[data-variant-select]')) updateVariant(event.target.closest('[data-product-section]'), event.target.value); });
document.addEventListener('submit', event => {
  const form = event.target.closest('.product-form');
  if (!form) return;
  event.preventDefault();
  addProductToCart(form).catch(() => { window.location.href = '/cart'; });
});
document.addEventListener('focusin', event => { const button = event.target.closest('[data-menu-trigger]'); if (button && !button.closest('[data-header]').dataset.suppressMenuFocus) openMenu(button.closest('[data-header]'), button); });
document.addEventListener('keydown', event => {
  if (event.key === 'Escape') { if (getCartDrawer()?.getAttribute('aria-hidden') === 'false') closeCartDrawer(); document.querySelectorAll('[data-header]').forEach(header => closeMenus(header, true)); }
  const trigger = event.target.closest('[data-menu-trigger]');
  if (trigger && desktop.matches && ['ArrowDown', 'Enter', ' '].includes(event.key)) {
    event.preventDefault();
    openMenu(trigger.closest('[data-header]'), trigger);
    document.getElementById(trigger.getAttribute('aria-controls'))?.querySelector('a, button')?.focus();
  }
  const tab = event.target.closest('[data-nav-tab]');
  if (tab && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
    event.preventDefault(); const tabs = [...tab.closest('.mobile-tabs').querySelectorAll('[data-nav-tab]')]; let index = tabs.indexOf(tab);
    if (event.key === 'Home') index = 0; else if (event.key === 'End') index = tabs.length - 1; else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    activateTab(tabs[index]); tabs[index].focus();
  }
});
desktop.addEventListener('change', () => { document.querySelectorAll('[data-header]').forEach(header => closeMenus(header)); document.querySelectorAll('[data-footer-menu]').forEach(details => { details.open = desktop.matches; }); if (desktop.matches) document.querySelectorAll('[data-mobile-navigation][open]').forEach(closeDialog); });
document.addEventListener('shopify:section:load', event => initialize(event.target));
document.addEventListener('shopify:section:unload', event => { event.target.querySelectorAll('dialog[open]').forEach(closeDialog); event.target.querySelectorAll('[data-header]').forEach(header => { const resources = headerControllers.get(header); resources?.controller.abort(); resources?.observer.disconnect(); headerControllers.delete(header); }); });
initialize();
